import React, { Component } from "react";
import CaseListComponent from "./CaseList";
import { filterLogsDataServices, userMapDataServices, downloadSystemLogFolder } from "../../services/java/java-services";
import { logger } from '../../services/logger/logger-service';
import { loggerEventOutcome, loggerEventTypes, loggerEventName } from '../../helpers/messages';
import { getUserRoleType, getUserName } from "../../services/aws/aws-services";
import { MappingRoles } from '../../helpers/constants';
let startDate;
export default class CaseListContainer extends Component {
	constructor(props) {
		super(props);
		this.state = {
			userList: [],
			caseList: [],
			loading: false,
			searched: false,
			searchError: null,
			region: "",
			searchParams: null,
			isFilePreparing:false,
			downloadError: null,
			downloadSuccess: false
		};
	}

	componentDidMount() {
		// initialize the start date on page load
		startDate = new Date();
		window.addEventListener('beforeunload', this.applicationLogger);
	}

	componentWillUnmount() {
		window.removeEventListener('beforeunload', this.applicationLogger);
		this.applicationLogger();
	}

	/**
	* @description function to handle application logs
	* @param {*}
	* @memberof Settings
	*/
	applicationLogger(key) {
		// calculate the time since we loaded this page
		const timeSinceLoad = (new Date().getTime() - startDate.getTime()) / 1000;
		const role = getUserRoleType()
		const userRole = MappingRoles.find(x => x.userRole === role.toLowerCase())?.specialLabel || role;
		const loggerObj = {
			EventOutcome: loggerEventOutcome.success,
			EventType: loggerEventTypes.read,
			EventName: loggerEventName.systemLogsList,
			Content: {
				TimeSpent: timeSinceLoad,
				Data: loggerEventName.systemLogAccessed(getUserName(), userRole),
			},
		};
		logger(loggerObj);
	}

	/**
	 * @description Fetch user list from API
	 * @memberof CaseListContainer
	 */
	getUserList = (region) => {
		if (!region) return;
		const urlParams = { region };
		userMapDataServices(urlParams, (err, response) => {
			if (err) {
				this.setState({ region, userList: [], searchError: err });
			} else {
				this.setState({ region, userList: response?.data || [], searchError: null });
			}
		});
	};

	/**
	 * @description API Call after submit button
	 * @memberof CaseListContainer
	 */
	handleSearchSubmit = (urlParams) => {
		this.setState({ loading: true, searchParams: urlParams, searched: true });
		filterLogsDataServices(urlParams, (err, response) => {
			if (err) {
				this.setState({ loading: false, caseList: [], searchError: err });
			} else {
				const caseListResponse = response?.data?.searchResponse || {};
				let caseList = [];
				for (const key in caseListResponse) {
					if (Object.prototype.hasOwnProperty.call(caseListResponse, key)) {
						const element = caseListResponse[key];
						if (element && typeof element === 'object') {
							if (element.children?.length) {
								element.children.forEach(x => {
									x["source"] = element.name;
									x["showDownload"] = true;
									x['bucketName'] = caseListResponse[`${key}Bucket`];
									caseList.push(x);
								})
							}
						}
					}
				}
				this.setState({ caseList, loading: false, searchError: null });
			}
		});
	};

	/**
	 * @description  Handle filter reset
	 * @memberof CaseListContainer
	 */
	handleReset = () => {
		this.setState({ caseList: [], loading: false, searchError: null, searched: false, downloadError: null,downloadSuccess: false, isFilePreparing: false });
	};

	/**
	 * @description  Handle file download from api
	 * @memberof CaseListContainer
	 */
	handleDownload = (item) => {
		const downloadParams = {
			region: this.state.region,
			fileName: item.name,
			path: item.path,
			phivalue: item.phivalue,
			bucketName: item.bucketName
		}
		this.setState({ isFilePreparing: true, downloadError: null });
		downloadSystemLogFolder(downloadParams, (err, response) => {
			if (err) {
				this.setState({ isFilePreparing: false, downloadError: err });
			// reset download error message after 10 seconds
			setTimeout(() => {
               this.setState({ downloadError: null });
            }, 10000);
			} else {
				this.downloadAsFile(response.data?.downloadURL, item.name);
			}
		});
	}
	
	/**
	 * @description Function to handle download the file
	 * @param downloadURL String to be downloaded
	 * @param filename String custom filename
	 * @memberof DeviceDetailsContainer
	 */
	downloadAsFile = (downloadURL, filename) => {
		let filenameBreakdown = filename.split('.');
		let fileExtension = filenameBreakdown.length ? filenameBreakdown[filenameBreakdown.length - 1] : '';

		const a = document.createElement("a");
		a.style = "display:none";
		a.href = downloadURL;
		a.download = fileExtension === 'zip' ? filename : `${filename}.zip`;
		a.click();
		URL.revokeObjectURL(a.href);
		a.remove();
		this.setState({ isFilePreparing: false, downloadError: null, downloadSuccess: true });

		// reset download success message after 10 seconds
		setTimeout(() => {
			this.setState({ downloadSuccess: false });
		}, 10000)
	};

	render() {
		const { userList, caseList, loading, region, searchError, searched, searchParams, isFilePreparing, downloadError, downloadSuccess } = this.state;
		return (
			<CaseListComponent
				userList={userList}
				caseList={caseList}
				handleReset={this.handleReset}
				handleSearchSubmit={this.handleSearchSubmit}
				loading={loading}
				getUserList={this.getUserList}
				searchError={searchError}
				searched={searched}
				searchParams={searchParams}
				region={region}
				handleDownload={this.handleDownload}
				downloadSuccess={downloadSuccess}
				isFilePreparing={isFilePreparing}
				downloadError={downloadError}
			/>
		);
	}
}
